import * as types from "./mutation-types";
import config from "@/store/config";
import moment from "moment";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  setDoc,
  getDocs,
  doc,
} from "firebase/firestore";

export const getAllStores = ({ commit }, payload) => {
  // Initialize Firebase
  return new Promise((resolve, reject) => {
    if (config) {
      const stores = [];
      const firebase = initializeApp(config);
      const db = getFirestore(firebase);
      const q = query(collection(db, "stores"), where("status", "in", ["published", "disabled", "review", "partner"])
      );
      const querySnapshot = getDocs(q);
      querySnapshot
        .then((docs) => {
          docs.forEach((doc) => {
            const document = doc.data()
            if (!document.hasOwnProperty('options')) {
              document.options = {}
              if (!document.options.hasOwnProperty('priceView')) {
                document.options.priceView = false
              }
            }
            if(payload.profile && payload.profile.whitelabelId){
              document.master = true;
              if(document.id == payload.profile.whitelabelId){
                stores.push(document);  
              }
            }
            else{
              stores.push(document);
            }
          });
          localStorage.setItem("stores", JSON.stringify({ stores: stores }));
          commit(types.GET_ALL_STORES, stores);

          resolve(stores);
        })
        .catch((err) => {
          reject(err);
        });
    }
  });

};

export const getMasterStore = ({ commit }) => {
  commit(types.GET_MASTER_STORE);
};
export const getSubStores = ({ commit }) => {
  commit(types.GET_SUB_STORES);
};

export const getSelectedStore = ({ commit }, payload) => {
  commit(types.GET_SELECTED_STORE, payload);
};

export const setValueInStore = ({ commit }, payload) => {
  commit(types.SET_VALUE_IN_STORE, payload);
};

export const saveStore = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    if(config){
    console.log("Saving...", payload);
    const form = JSON.parse(JSON.stringify(payload));
    form.info.audience.gender.male = parseFloat(form.info.audience.gender.male);
    form.info.audience.gender.female = parseFloat(
      form.info.audience.gender.female
    );
    form.updatedOn = moment().format();
    // Initialize Firebase
    const firebase = initializeApp(config);
    const db = getFirestore(firebase);
    const docRef = doc(db, "stores", payload.id);
    const querySnapshot = setDoc(docRef, form);
    querySnapshot.then(() => {
      commit(types.SAVE_STORE, payload);
      resolve(true)
    }, err => {
      reject(err)
    });
  }
  })
};

